import { useState } from "react"
import { useNavigate } from "react-router-dom"

import Style from "./style"
import leftBlack from "./asset/left_black.svg"
import leftGrey from "./asset/left_grey.svg"
import rightBlack from "./asset/right_black.svg"
import rightGrey from "./asset/right_grey.svg"

import MainHeader from "widget/MainHeader"

import useGetAdvertiseDetail from "entity/advertise/useGetAdvertiseDetail"
import useDeleteAdvertise from "entity/advertise/useDeleteAdvertise"

import DTStyle from "shared/style/detailTableStyle"
import useConfirmModalAtom from "shared/model/useConfirmModalAtom"
import timestampCalculator from "shared/lib/timestampCalculator"

const AdDetail = () => {
    const navigate = useNavigate()

    const [imgIndex, setImgIndex] = useState(0)

    const [advertiseData] = useGetAdvertiseDetail()
    const [deleteAdvertise] = useDeleteAdvertise()

    const [, setConfirm] = useConfirmModalAtom()

    const btnList = [
        {
            "label": "수정",
            "clickEvent": () => navigate(`/ad/${advertiseData?.data?.idx}/edit`),
            "deactive": false
        },
        {
            "label": "삭제",
            "clickEvent": () => setConfirm("정말 삭제할까요?", () => deleteAdvertise),
            "deactive": false
        },
    ]
    const noticeDataList = [
        {
            "label": "IDX",
            "value": advertiseData?.data?.idx
        },
        {
            "label": "연결 링크",
            "value": advertiseData?.data?.url || "-"
        },
        {
            "label": "상태",
            "value": advertiseData?.data?.is_active ? "활성" : "미활성"
        },
        {
            "label": "생성 날짜",
            "value": timestampCalculator(advertiseData?.data?.created_at)
        },
    ]
    const bannerImg = advertiseData?.data?.banner_img
    const mainImg = advertiseData?.data?.img_list

    return (
        <Style.Wrapper>
            <MainHeader btnList={btnList} />

            <Style.AreaDiv>
                <h2>광고 데이터</h2>
                <DTStyle.TableDiv>
                    {noticeDataList?.map((elem, index) =>
                        <DTStyle.TableElement key={index}>
                            <h2>{elem?.label}</h2>
                            <p>{elem?.value}</p>
                        </DTStyle.TableElement>
                    )}
                </DTStyle.TableDiv>
            </Style.AreaDiv>

            <Style.AreaDiv>
                <h2>배너 이미지</h2>
                <Style.ContentImg src={bannerImg} />
            </Style.AreaDiv>

            {mainImg?.length > 0 &&
                <Style.AreaDiv>
                    <h2>본문 이미지</h2>
                    <Style.SliderDiv>
                        <button onClick={() => setImgIndex(state => state > 0 ? state - 1 : state)}>
                            <img src={imgIndex === 0 ? leftGrey : leftBlack} />
                        </button>
                        <button onClick={() => setImgIndex(state => state < mainImg?.length - 1 ? state + 1 : state)}>
                            <img src={imgIndex === mainImg?.length - 1 ? rightGrey : rightBlack} />
                        </button>
                    </Style.SliderDiv>
                    <Style.ContentImg src={mainImg[imgIndex]} />
                </Style.AreaDiv>
            }

        </Style.Wrapper>
    )
}

export default AdDetail